import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// action
import { registerUser, apiError, registerUserFailed } from "../../store/actions"

// Redux
import { connect } from "react-redux"
import { Link, useHistory } from "react-router-dom"

import store from 'store';
import { SET_CODE } from 'store/auth/data/actionTypes';
import { getCode } from "crud/auth.crud";
import { useSelector } from 'react-redux';

import RegisterBar from "./RegisterBar";

// import images
import weaver from "../../assets/images/weaver.png";
import emitter from "../../assets/images/emitter.png";
import emitter_on from "../../assets/images/emitter_on.png";
import demand from "../../assets/images/demand.png";
import demand_on from "../../assets/images/demand_on.png";
import collection from "../../assets/images/collection.png";
import collection_on from "../../assets/images/collection_on.png";
import treatment from "../../assets/images/treatment.png";
import treatment_on from "../../assets/images/treatment_on.png";
import logo_long from "assets/images/logo-long.png"

const typeArray = [
  {id : 'emitter', selectedImagePath : emitter_on, imagePath : emitter, text: '배출자', explain: '음식물폐기물을 배출합니다.'},
  {id : 'collection', selectedImagePath : collection_on, imagePath :collection, text: '수집운반업체', explain: '폐기물을 수거하고 처리장까지 운반합니다.'},
  {id : 'treatment', selectedImagePath : treatment_on, imagePath : treatment, text: '처리장', explain: '폐기물을 처리하고 재생원료를 만듭니다.'},
  {id : 'demand', selectedImagePath : demand_on, imagePath : demand, text: '수요기업', explain: '재생원료를 구입·사용합니다.'},
]

// const selectUserType = (id) => {
//   this.setState({userType : id})
// }
// onClick={()=>{ return setUserType(item.id);}}

const Register = props => {
  const selector = useSelector(state => state)
  const history = useHistory();
  const [memberType, setMemberType] = useState('emitter');

  useEffect(() => {
    props.apiError("")
  }, []);

  const handleClick = (memberType) => {
    const url = {
      pathname : `/terms`,
      state : {userType : memberType} 
    }
    history.push(url);
  }

  useEffect( async()=>{
    const rs = await getCode()
    store.dispatch({ type: SET_CODE, data: [rs.data]})
  }, [])

  return (
    <React.Fragment>
      <MetaTags>
        <title>회원가입 | 웨이스트버스</title>
      </MetaTags>
      <div className="account-pages my-4 px-1">
        <Container className="membership-box">
          <Link to="">
            <img src={logo_long} className="mb-4" />
          </Link>
          <RegisterBar className="margin-bottom-48" circleNumber={5} actionNumber={1} title="회원선택" />
          <Row className="justify-content-center">
            {/* <Col md={8} lg={6} xl={12}>
              <Card className="overflow-hidden">
                <CardBody className="p-4">
                  <div className="p-3"> */}

                      <div style={{margin: 'auto'}}>
                        { typeArray.map((item, index)=>{
                          return (
                            <div className="bg-white pointer radius-4" key={item.id+'_'+index} style={{width: 'calc((100% - 24px) / 2)', float: index % 2 === 0 ? 'left' : 'right', marginLeft: index % 2 === 1 && 24, padding: 24, marginBottom: index < 2 && 24}} onClick={() => {handleClick(item.id)}}>
                              <p className="font-size-16 font-weight-bold text-primary noMargin mb-0" style={{lineHeight: '140%'}}>
                                {item.text}<span className="text-black"> 회원</span>
                              </p>
                              <p className="font-size-14 text-gray padding-top-8 mb-0" style={{lineHeight: '140%'}}>{item.explain}</p>
                            </div>
                        )})}
                      </div>

                  {/* </div>
                </CardBody>
              </Card> */}
              <div className="mt-5 text-center">
                <p>
                  이미 계정이 있습니까 ?{" "}
                  <Link to="/login" className="fw-medium text-primary">
                    {" "}
                    로그인
                  </Link>{" "}
                </p>
                <p className="text-silver font-size-12">
                  © {new Date().getFullYear()} Wasteverse
                </p>
              </div>
            {/* </Col> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Register.propTypes = {
  registerUser: PropTypes.func,
  registerUserFailed: PropTypes.func,
  registrationError: PropTypes.any,
  user: PropTypes.any,
}

const mapStatetoProps = state => {
  const { user, registrationError, loading } = state.Account
  return { user, registrationError, loading }
}

export default connect(mapStatetoProps, {
  registerUser,
  apiError,
  registerUserFailed,
})(Register)
